import React, { useEffect, useState } from "react";

function ToyOrderHistory() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

const toyData = [
  { id: "toy1", src: "Group71.png", price: 480 },
  { id: "toy2", src: "Group71.png", price: 480 },
  { id: "toy3", src: "Group71.png", price: 480 },
  { id: "toy4", src: "Group71.png", price: 480 },
  { id: "toy5", src: "Group71.png", price: 480 },
  { id: "toy6", src: "Group71.png", price: 480 },
  { id: "toy7", src: "Group71.png", price: 480 },
  { id: "toy8", src: "Group71.png", price: 480 },
  { id: "toy9", src: "Group71.png", price: 480 },
  { id: "toy10", src: "Group71.png", price: 480 },
  { id: "toy11", src: "Group71.png", price: 480 },
  { id: "toy12", src: "Group71.png", price: 480 },
];

  const apiBaseUrl = (process.env.REACT_APP_API_URL || "http://localhost:5000").replace(/\/$/, "");

  // ✅ Sync user from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    const syncUser = () => {
      const updatedUser = localStorage.getItem("user");
      if (updatedUser) {
        setUser(JSON.parse(updatedUser));
      } else {
        setUser(null);
      }
    };

    window.addEventListener("storage", syncUser);
    return () => window.removeEventListener("storage", syncUser);
  }, []);

  // ✅ Fetch purchase history for logged-in user's email
  useEffect(() => {
    const userEmail = user?.email;
    if (!userEmail) {
      setOrders([]);
      setLoading(false);
      return;
    }

    setLoading(true);

    fetch(`${apiBaseUrl}/api/orders?email=${encodeURIComponent(userEmail)}`)
      .then(async (res) => {
        if (!res.ok) {
          console.error("Failed to fetch orders:", res.statusText);
          return [];
        }
        const data = await res.json();
        return Array.isArray(data) ? data : [];
      })
      .then((data) => {
        setOrders(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
        setOrders([]);
        setLoading(false);
      });
  }, [apiBaseUrl, user]);

  if (!user?.email) {
    return (
      <div className="text-white text-center py-8">
        Please log in to view your purchase history.
      </div>
    );
  }

  if (loading) {
    return <div className="text-white">Loading...</div>;
  }

  return (
    <div className="w-full max-w-2xl bg-[#2a2540] rounded-2xl p-6 shadow-2xl lg:max-w-7xl lg:rounded-[32px] lg:p-16 frame-sd52 mt-[20px]">
      <div className="text-2xl font-bold mb-6 text-pink-400">Toy Purchase History</div>

      {/* ✅ Scrollable wrapper for mobile */}
      <div className="overflow-x-auto">
        <table className="min-w-full text-left">
          <thead>
            <tr className="bg-[#2f2a47] text-white text-lg">
              <th className="py-4 px-3">ID</th>
              <th className="py-4 px-3">Toy</th>
              <th className="py-4 px-3">Quantity</th>
              <th className="py-4 px-3">Unit Price</th>
              <th className="py-4 px-3">Total Amount</th>
              <th className="py-4 px-3">Address</th>
              <th className="py-4 px-3">Status</th>
              <th className="py-4 px-3">Date</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan={100} className="text-center text-white py-6">
                  No purchase data found.
                </td>
              </tr>
            ) : (
              orders.map((order) => (
                <tr key={order.id} className="text-white text-lg border-b border-[#503564]">
                  <td className="py-4 px-3">{order.id}</td>
                  <td className="py-4 px-3">
                    {(() => {
                      const toy = toyData.find((t) => t.id === order.toy_id);
                      return toy ? (
                        <div className="w-20 h-20 flex items-center justify-center border border-pink-300 rounded">
                          <img
                            src={toy.src}
                            alt={order.toy_id}
                            className="max-w-full max-h-full"
                          />
                        </div>
                      ) : (
                        order.toy_id
                      );
                    })()}
                  </td>
                  <td className="py-4 px-3">{order.quantity}</td>
                  <td className="py-4 px-3">
                    ${order.unit_price ? (order.unit_price / 100).toFixed(2) : "0.00"}
                  </td>
                  <td className="py-4 px-3">
                    ${order.total_amount ? (order.total_amount / 100).toFixed(2) : "0.00"}
                  </td>
                  <td className="py-4 px-3">{order.address}</td>
                  <td className="py-4 px-3">{order.payment_status}</td>
                  <td className="py-4 px-3">
                    {order.created_at ? new Date(order.created_at).toLocaleString() : ""}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ToyOrderHistory;
